/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function ThumbsDownSolid({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="currentColor">
            <g clipPath="url(#clip0_418_2319)">
                <path d="M10.7338 1.36633H10.1006C9.76479 1.36633 9.44272 1.49165 9.20525 1.7147C8.96778 1.93776 8.83437 2.24029 8.83437 2.55574V7.90809C8.83437 8.06581 8.90108 8.21708 9.01981 8.32861C9.13855 8.44014 9.29958 8.50279 9.4675 8.50279H11.3669C11.5348 8.50279 11.6958 8.44014 11.8146 8.32861C11.9333 8.21708 12 8.06581 12 7.90809V2.55574C12 2.24029 11.8666 1.93776 11.6291 1.7147C11.3917 1.49165 11.0696 1.36633 10.7338 1.36633Z" />
                <path d="M7.56813 2.92268H7.49595C6.16069 2.57656 4.39364 1.96104 2.75701 1.96104C1.87063 1.96104 1.74907 2.27385 1.56737 2.74367L0.0763554 6.9066C0.00676303 7.08622 -0.0157213 7.27894 0.0108069 7.46844C0.0373351 7.65795 0.112094 7.83866 0.228753 7.99527C0.345411 8.15188 0.500532 8.27977 0.680978 8.36812C0.861424 8.45646 1.06188 8.50266 1.26536 8.50279H3.77001L2.78487 11.179C2.75274 11.4238 2.81273 11.6715 2.95446 11.8792C3.09618 12.0869 3.31073 12.2416 3.56099 12.3165C3.81126 12.3913 4.08151 12.3817 4.325 12.2892C4.56849 12.1967 4.76992 12.0272 4.89444 11.8099C5.62563 10.6367 6.52602 9.56395 7.57003 8.62233L7.56813 2.92268Z" />
            </g>
            <defs>
                <clipPath id="clip0_418_2319">
                    <rect width="12" height="12" fill="white" transform="translate(0 0.866333)" />
                </clipPath>
            </defs>
        </svg>
    );
}
